@if (listButton.length > 1) {
  <button
    #actionTrigger
    nz-button
    nz-dropdown
    [nzDropdownMenu]="menu4"
    class="fancy-button"
    nzTrigger="hover"
    (nzVisibleChange)="onMenuVisibleChange($event)"
    (click)="isMenuShown = true"
    (keydown)="onTriggerKeydown($event)"
    [(nzVisible)]="isMenuShown"
    [attr.aria-haspopup]="'menu'"
    [attr.aria-expanded]="isMenuShown"
  >
    Select an Action <i class="fa fa-chevron-right" aria-hidden="true"></i>
  </button>

  <nz-dropdown-menu #menu4="nzDropdownMenu">
    @if (isMenuShown) {
      <ul
        #menuDropdown
        nz-menu
        class="action-menu"
        pplFocusTrap
        role="menu"
        (escape)="isMenuShown = false; focusActionTrigger()"
      >
        @for (btns of listButton; track $index) {
          <li
            nz-menu-item
            class="action-item"
            role="menuitem"
            [nzSelected]="false"
            [attr.id]="'action-opt-' + $index"
            [attr.tabindex]="$index === actionActiveIndex ? 0 : -1"
            [attr.aria-setsize]="listButton.length"
            [attr.aria-posinset]="$index + 1"
            (click)="actionClicked(btns, $event)"
            (keydown)="onActionMenuKeydown($event)"
          >
            <span class="action-btn-label">{{ btns.button_label }}</span>
          </li>
        }
      </ul>
    }
  </nz-dropdown-menu>
}

@if (listButton.length === 1) {
  <button nz-button (click)="actionClicked(listButton[0], $event)" class="fancy-button">
    {{ listButton[0].button_label }}
  </button>
}
<ppl-popup-dialog 
      [(isVisible)]="show" 
      [title]="title" 
      [isOkText]="okText"
      (confirm)="handleOk()"
      (cancel)="handleCancel()"
      [showButtons] = "true"
      [showOkButton]="false"
      [size]="'medium'"
      [position]="'center'">
      @if(showApproved){
        <div class="ppl-p24">
            <p class="ppl-gray-text ppl-mt20">Your Application is approved.</p>
            <p>An email/SMS has been sent to you with a registration link to proceed.</p>
        </div>
      }
      @else {
        @if(title==="Update Status"){
                <ppl-dropdown-select [(ngModel)]="listOfSelectedValueStatus" style="width:100%; margin-bottom: 16px"
                    [options]="listOfOtherOptions" 
                    placeholder="{{placeholderStatus}}"></ppl-dropdown-select>
        }

      @if(!['Assign to me', 'Send SMS', 'Send Email', 'Review Complete'].includes(title) && flow !== 'authorizations'){
            @if (title==='Assign to User' && selectedCheckBoxValue.length>1) {
                <ppl-multiselect [(ngModel)]="listOfSelectedValue" style="width:100%; margin-bottom: 16px"
                 [options]="listOfOption" [showClear]="false" placeholder="{{placeholder}}" >
            </ppl-multiselect>
            }
            @else {
                <ppl-dropdown-select [(ngModel)]="listOfSelectedValue" style="width:100%; margin-bottom: 16px"
                [options]="listOfOption" [showClearButton]="false" placeholder="{{placeholder}}"></ppl-dropdown-select>
            }
        }
        
        @if(['Send SMS', 'Send Email'].includes(title)){
            <p>Note that the {{type}} will be sent to the {{notificationType}} specified in Contact Details under the profile.</p>
        }
        @if(title==='Approve' && (flow === 'provider' || flow === 'participant')){
            <ppl-dropdown-select [(ngModel)]="selectedProgram" id="selectedProgram"
                style="width:100%; margin-bottom: 16px" 
                [options]="programs" [optionLabel]="'program_name'"
                [optionValue]="'program_code'"
                placeholder="Please select Program"></ppl-dropdown-select>
        }
        @if (type === 'Email') {
            <div class="form-group">
                <label for="subject">Subject</label>
                <nz-textarea-count [nzMaxCharacterCount]="500">
                <textarea rows="3" nz-input id="subject" [(ngModel)]="subject"
                    placeholder="Start typing..." maxlength="500"></textarea>
                </nz-textarea-count>
                @if(noSubject){
                    <p class="error-message">Please enter a Subject.</p>
                }
            </div>
        }

        <div class="form-group">
            <label for="comments">{{labelForText}}</label>
            <nz-textarea-count [nzMaxCharacterCount]="title === 'Send SMS' ? 160 : 10000">
            <textarea rows="3" nz-input id="comments" [(ngModel)]="comments"
                placeholder="Start typing..." [maxlength]="title === 'Send SMS' ? 160 : 10000"></textarea>
            </nz-textarea-count>
            @if(noMessage){
                <p class="error-message">Please enter a message.</p>
            }
            @if(title === 'Send SMS' && mobileErr) {
                <span class="pl-1 error-message">Please add mobile number before sending SMS</span>
            }
        </div>
    }
    </ppl-popup-dialog>

    <ppl-popup-dialog [(isVisible)]="showProcessing" [title]="'Approval Received'" [isOkText]="'Close'"
      (cancel)="onProcessingClose()" [showButtons]="false" [position]="'center'" size="medium" [showOkButton]="true">
      <div class="ppl-p24">
        <p class="ppl-gray-text ppl-mt20">
          Your approval is currently being processed.
        </p>
      </div>
    </ppl-popup-dialog>

    <div class="filter-panel">
        <ng-template #payrollDialog let-cancel="cancel">
            <p>Please enter check date: </p>
            <ppl-date-picker [(ngModel)]="selectedDate" id="selectedDate" 
            [placeholder]="'Select date'" dateFormat="mm/dd/yy" [yearRange]="'1900:2050'" [iconDisplay]="'input'"
            inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'" [maxDate]="maxDate"
            [minDate]="minDate">
          </ppl-date-picker>
        </ng-template>
      </div>
